import clsx from 'clsx'
import {memo} from 'react'

import {classes} from './MobileDrawer.classes'

type FooterProps = React.PropsWithChildren<{}> & JSX.IntrinsicElements['div']

export const DrawerFooter = memo(function DrawerFooter({children, ...props}: FooterProps) {
  return (
    <div className={clsx(classes.footer, classes.footerStuck)} {...props}>
      {children}
    </div>
  )
})
